<template>
  <v-card>
    <v-toolbar dense elevation="1">
      <v-spacer />
      <v-toolbar-title>
        グループ編集
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="clearAll" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              v-model="selectedGroup.name"
              item-text="name"
              label="グループ名"
              prepend-icon="mdi-folder"
              autofocus
              chips
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="red" outlined @click="deleteGroup">
        グループを削除
        <v-icon right>mdi-delete</v-icon>
      </v-btn>
      <v-btn color="success" outlined @click="updateUnit">
        変更を保存
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  updateDeviceGroup,
  deleteDeviceGroup
} from '@/firebaseAccess/firestoreAccess'

export default {
  name: 'DeviceUnitEditDialog',
  props: {
    selectedDevice: {
      type: Object,
      required: true
    },
    selectedGroup: {
      type: Object,
      required: true
    },
    devices: {
      type: Array,
      required: true
    }
  },
  data: () => ({}),
  methods: {
    clearDraftGroup() {
      this.selectedDevices = []
    },
    clearAll() {
      this.$emit('clickClear')
      this.clearDraftGroup()
    },
    updateUnit() {
      updateDeviceGroup(this.selectedGroup.id, this.selectedGroup, true)
      this.clearAll()
    },
    deleteGroup() {
      // delete group from all devices
      for (const device of this.devices) {
        device.groups = device.groups.filter(d => d !== this.selectedGroup.id)
        this.$emit('updateDevice', device)
      }
      deleteDeviceGroup(this.selectedGroup.id)
      this.clearDraftGroup()
    }
  }
}
</script>
